import React from "react";
import ErrorIndicator from "../components/state-indicators/error-indicator";
import Spinner from "../components/state-indicators/spinner";
const withLoadingData = (Wrapped, Error = ErrorIndicator, Loader = Spinner) => {
    return class WithData extends React.Component {
        state = {
            error: false,
            loading: false,
            data: null
        };

        componentDidMount() {
            const { getData } = this.props;
            this.setState({
                error: false,
                loading: true,
                data: null
            });
            getData(this.props)
                .then(data => {
                    this.setState({
                        loading: false,
                        data
                    });
                })
                .catch(() => {
                    this.setState({
                        error: true,
                        loading: false,
                        data: null
                    });
                });
        }
        render() {
            const { error, loading, data } = this.state;
            return error ? <Error /> : loading ? <Loader /> : <Wrapped {...this.props} data={data} />;
        }
    };
};

export default withLoadingData;
